export interface AiVideoStatistics {
    [key: string]: number;
}

export interface AiVideoRecord {
    id: number;
    url: string;
    pic: string;
    aiStatus: number;
    aiStartTime: number;
    aiEndTime: number;
    aiTime: number;
}

export interface AiVideoListResponse {
    items: AiVideoRecord[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
    orderBy: string;
    orderDirection: string;
}

export const AI_STATUS_MAP: { [key: number]: string } = {
    0: 'Pending',
    1: 'Processing',
    2: 'Failed',
    9: 'Completed',
};

export const AI_STATUS_CHOICES = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Processing' },
    { id: 2, name: 'Failed' },
    { id: 9, name: 'Completed' },
];
